import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";
import SectionHeading from "components/shared/SectionHeading";
import SubText from "components/shared/SubText";
import PayperviewPickedout from "components/skeleton/PayperviewPickedout";
import { RouteName } from "constant/routeNames";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PayperviewService from "services/payperview/PayperviewServie";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const PayPerViewCard = lazy(
  () => import("pages/PayPerView/shared/PayPerViewCard")
);

function WelcomePagePayperview() {
  const [upComingEvents, setUpComingEvents] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    PayperviewService.getAllPayperviewEvents()
      .then((res) => {
        // console.log("event", res.data);
        setIsLoading(false);
        const upComingEvent = res?.data.filter(
          (event: any) => event?.event_status === "not started"
        );
        setUpComingEvents(upComingEvent);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);
  return (
    <>
      {!isLoading && (
        <ErrorBoundary>
          <Suspense fallback={<PayperviewPickedout />}>
            <div className="mb-10">
              {upComingEvents?.length > 0 && (
                <>
                  {/* top section */}
                  <div className="mt-10 mb-5 flex w-[95%] items-center justify-between">
                    <div>
                      <SectionHeading   
                        text="Discover Payperview Events"
                        className="font-bold"
                      />
                    </div>
                    <Link
                      to={RouteName.upcomingSeeAllRoute}
                      className="group shrink-0"
                    >
                      <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
                        See all
                        <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                          →
                        </span>
                      </p>
                    </Link>
                  </div>

                  <div>
                    <Swiper
                      slidesPerView={7}
                      breakpoints={{
                        0: {
                          slidesPerView: 1,
                        },
                        370: {
                          slidesPerView: 2,
                        },
                        700: {
                          slidesPerView: 3,
                        },
                        1000: {
                          slidesPerView: 4,
                        },
                        1200: {
                          slidesPerView: 4,
                        },
                        1400: {
                          slidesPerView: 4,
                        },
                        1600: {
                          slidesPerView: 4,
                        },
                      }}
                      modules={[Pagination, Navigation]}
                      navigation={true}
                      className="mt-4 mb-5 mySwiper"
                    >
                      {upComingEvents &&
                        upComingEvents?.map((event: any, i: number) => (
                          <SwiperSlide key={i}>
                            <div className="px-1.5 max-sm:px-1">
                              <PayPerViewCard event={event} />
                            </div>
                          </SwiperSlide>
                        ))}
                    </Swiper>
                  </div>
                </>
              )}
            </div>
          </Suspense>
        </ErrorBoundary>
      )}
      {isLoading && <PayperviewPickedout />}
    </>
  );
}
export default WelcomePagePayperview;